<template>
<div class="main-container">
    <div class="inner-container">
        <signed-in-user-info :user="user" :userData="userData" :loadingUser="loadingUser"/>
        <div class="track-shipment update-user">
            <loading-charts v-if="loadingUser" class="loading-charts"/>
            <div class="user-info">
                <div class="inner-overflow-container" id="inner-overflow-container">
                    <div v-if="selectedPartner != ''" class="selected-partner">
                        <h3><span style="font-weight: 1;">Selected Partner: </span>{{selectedPartner}}</h3>
                        <button class="reset-button" @click="resetSelectedPartner()">Reset</button>
                    </div>
                    <div v-if="(selectedPartner == 'P2PGlobal') || selectedPartner == ''" @click="selectPartner('P2PGlobal')" class="partner-option">
                        <img src="../../../assets/FinalImages/P2PGlobal.png" alt="">
                    </div>
                    <div v-if="false" @click="selectPartner('USPSEconomy')" class="partner-option">
                        <img src="../../../assets/FinalImages/uspsLogo.png" alt="">
                    </div>
                    <div v-if="(selectedPartner == 'UPS') || selectedPartner == ''" @click="selectPartner('UPS')" class="partner-option">
                        <img src="../../../assets/FinalImages/upsLogo.png" alt="">
                    </div>
                    <div v-if="(AdminUser || InternalAdmin)">
                        <div v-if="selectedPartner == 'P2PGlobal'" class="confirmLabelContainer">
                            <form class="submit-form" @submit.prevent="submitForm">
                                <input v-model="shipmentID" placeholder="Shipment ID" type="text" @keyup.enter="submitForm">
                                <button type="submit">Get Shipment</button>
                            </form>
                            <div v-if="shipmentData" class="shipment-data">
                                <div class="header-track-inner">
                                        <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 159.75 148.87">
                                            <g id="Layer_1-2" data-name="Layer 1">
                                                <path d="M154.27,12.53c.87-.17,1.78,0,2.54,.46,1.29,.53,2.2,1.79,2.2,3.28l.74,103.46c.07,1.27-.56,2.54-1.73,3.22l-42.25,25.21c-.6,.46-1.34,.72-2.15,.72-.2,0-.39-.01-.57-.05L3.39,136.62c-1.89-.08-3.39-1.64-3.39-3.55V27.85H0c-.04-1.4,.75-2.77,2.13-3.37L57.14,.31h0c.57-.26,1.22-.36,1.9-.27l95.23,12.49h0Zm-37.27,30.93v96.48l36-21.47-.7-97.26-35.3,22.25h0Zm-7,97.91V45l-46.8-5.97-1.54,44.72-16.43-11.19-16.43,9.29,3.4-46.78-25.19-3.21v98.07l103,11.44h0ZM102.56,12.88l-34.52,19.59,44.9,5.72,31.47-19.83-41.86-5.49h0ZM36.56,28.46L70.02,8.61l-11.03-1.44L16.4,25.89l20.15,2.56h0Z"/>
                                            </g>
                                        </svg>
                                    <p style="font-weight: bold"> {{shipmentData.shipmentID}}</p>
                                </div>
                                <div v-if="shipmentData" class="address-info-container">
                                    <div class="address-info">
                                        <p style="font-weight: bold;">{{shipmentData.serviceAddress.address.companyName}}</p>
                                        <p>{{shipmentData.serviceAddress.address.address1}}</p>
                                        <p>{{shipmentData.serviceAddress.address.city}}, {{shipmentData.serviceAddress.address.state}} {{shipmentData.serviceAddress.address.zipCode}}</p>
                                        <p v-if="shipmentData.externalTrackingNumber"><span style="font-weight: bold">P2P Tracking: </span>{{shipmentData.externalTrackingNumber}}</p>
                                        <p><span style="font-weight: bold">LREX Tracking: </span>{{shipmentData.shipmentID}}</p>
                                    </div>
                                    <div class="check-mark-item"><img src="../../../assets/FinalImages/checkMark.png" alt=""></div>
                                </div>

                                <div class="service-type">
                                    <p>Service Type:</p>
                                </div>

                                <div class="signatureInputLabel" v-for="p2pServiceCodeOption in p2pServiceCodeOptions" :key="p2pServiceCodeOption">
                                    <label for="p2pServiceCode">P2P</label>
                                    <input type="radio" :value="p2pServiceCodeOption" v-model="p2pServiceCode" id="p2pServiceCode">
                                </div>
                                
                                <button  @click="createP2PParcel()" class="create-button">Create P2P Parcel</button>
                                <button @click="createP2PLabel()" class="create-label-button">Re-Create Label</button>
                            </div>
                    
                            <div class="label-container" id="label-container" v-if="labelData != null">
                                <shipment-label :baseLabelData="labelData" />
                            </div>
                        </div>  
                        <div v-if="selectedPartner == 'USPSEconomy'" class="confirmLabelContainer">
                            <form class="submit-form" @submit.prevent="getShipmentExternalTracking">
                                <input v-model="trackingNumber" placeholder="Tracking Number" type="text" id="trackingNumber" name="trackingNumber">
                                <button type="submit">Enter</button>
                            </form>
                            <embed v-show="showPDF" class="pdfViewer" id="pdfViewer" src="" width="100%" height="500" javascript="allow" full-frame>
                            <div v-if="p2pUSPSShipmentData" class="address-info-container">
                                <div class="address-info">
                                    <!-- {{p2pUSPSShipmentData.serviceAddress.address}} -->
                                    <p style="font-weight: bold;">{{p2pUSPSShipmentData.serviceAddress.address.companyName}}</p>
                                    <p>{{p2pUSPSShipmentData.serviceAddress.address.address1}}</p>
                                    <p>{{p2pUSPSShipmentData.serviceAddress.address.city}}, {{p2pUSPSShipmentData.serviceAddress.address.state}} {{p2pUSPSShipmentData.serviceAddress.address.zipCode}}</p>
                                    <p><span style="font-weight: bold">USPS Tracking: </span>{{p2pUSPSShipmentData.externalTrackingNumber}}</p>
                                    <p><span style="font-weight: bold">LREX Tracking: </span>{{p2pUSPSShipmentData.shipmentID}}</p>
                                </div>
                                <div class="check-mark-item"><img src="../../../assets/FinalImages/checkMark.png" alt=""></div>
                            </div>
                            <div v-if="toggleSubmitTripSheet == false">
                                <button class="finish-scanning-button" @click="toggleFinishScanning()">Finish Scanning</button>
                            </div>
                            <div v-if="toggleSubmitTripSheet == true">
                                <button class="finish-scanning-button" @click="endTripSheetP2PECO()">Submit</button>
                                <button @click="()=>{this.toggleSubmitTripSheet = false}" class="cancel-scanning-button">Cancel</button>
                            </div>
                        </div>    
                        <div v-if="selectedPartner == 'UPS'" class="confirmLabelContainer">
                            <form class="submit-form" @submit.prevent="GetShipmentData()">
                                <input v-model="shipmentID" placeholder="Shipment ID" type="text" id="shipmentID" name="shipmentID">
                                <button type="submit">Enter</button>
                            </form>
                            <div v-if="shipmentData" class="address-info-container">
                                <div class="address-info">
                                    <p style="font-weight: bold;">{{shipmentData.serviceAddress.address.companyName}}</p>
                                    <p>{{shipmentData.serviceAddress.address.address1}}</p>
                                    <p>{{shipmentData.serviceAddress.address.city}}, {{shipmentData.serviceAddress.address.state}} {{shipmentData.serviceAddress.address.zipCode}}</p>
                                    <p v-if="shipmentData.externalTrackingNumber"><span style="font-weight: bold">UPS Tracking: </span>{{shipmentData.externalTrackingNumber}}</p>
                                    <p><span style="font-weight: bold">LREX Tracking: </span>{{shipmentData.shipmentID}}</p>
                                </div>
                                <div class="check-mark-item"><img src="../../../assets/FinalImages/checkMark.png" alt=""></div>
                            </div>
                            <div v-if="shipmentData">
                                <button v-if="!shipmentData.externalTrackingNumber" class="finish-scanning-button" @click="CreateUPSShipment()">Create</button>
                                <button v-if="shipmentData.externalTrackingNumber" class="finish-scanning-button" @click="CreateUPSShipmentLabel()">Create Label</button>
                            </div>
                            <div v-if="UPSCreateShipmentData && UPSCreateShipmentData.shipmentLabel" class="ups-label-container">
                                <shipment-label :baseLabelData="'data:application/pdf;base64,' + UPSCreateShipmentData.shipmentLabel" />
                               </div>
                            <div v-if="UPSCreateShipmentData && UPSCreateShipmentData.shippingLabel" class="ups-label-container">
                                <shipment-label :baseLabelData="'data:application/pdf;base64,' + UPSCreateShipmentData.shippingLabel" />
                            </div>
                        </div>  
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div v-if="loadingData">
    <LoadingData :headerMessage="loadingDataMessage"/>
</div>
<AlertUser v-if="toggleAlertBox" @closeAlertBox="closeAlertBox($event)" :message="alertMessage"/>
</template>

<script>
import {Auth, API} from 'aws-amplify'
import LoadingCharts from '../../ShipmentDashboard/LoadingCharts.vue';
import AlertUser from '../../../components/Popups/AlertUser.vue';
import SignedInUserInfo from '../UserDashboard/SignedInUserInfo.vue';
import {createParcelP2P, createLabelP2P, createShipmentUPS, createLabelUPS} from '../../../graphql/mutations'
import ShipmentLabel from '../../ShipmentDashboard/ShipmentLabel.vue';
import LoadingData from '../../../components/Popups/LoadingData.vue';

export default {
    data(){
        return{
            user: {},
            p2pServiceCodeOptions: ["LREX"],
            p2pServiceCode: "LREX",
            userInput: "",
            labelData: null, 
            selectedPartner: "",
            selectedShipment: 'Current',
            jwtToken: null,
            loadingUser: false,
            loadingData: false,
            userData: {},
            userDataCognito: {},
            refreshKey: 0,
            placeHolder: "Search for address",
            validateCustomAddress: false,
            userCustomAddress: "",
            toggleAlertBox: false,
            AdminUser: false,
            InternalAdmin: false,
            CreateNewAccount: false,
            Customer: false,
            CustomerAdmin: false,
            ManagePrices: false,
            EditorGroup: false,
            createCognitoUserInput: {
                email: "",
                username: "",
                accountNo: "",
                locationID: ""
            },
            selectedUserData:{
                locationID: ""
            },
            // shipmentDataREST: {},
            p2pReturnData: {},
            trackingNumber: "",
            tripSheetID: null,
            P2PECORoute: "PPE",
            toggleSubmitTripSheet: false,
            loadingDataMessage: "Loading",
            p2pUSPSShipmentData: null,
            showPDF: false,
            shipmentID: "",
            shipmentData: null,
            UPSCreateShipmentData: {}
        }
    },
    components:{
        LoadingCharts,
        AlertUser,
        SignedInUserInfo,
        ShipmentLabel,
        LoadingData
    },
    mounted(){
        window.scrollTo(0,0);
        Auth.currentAuthenticatedUser().then(user => {
            this.user = user;
            this.jwtToken = user.signInUserSession.accessToken.jwtToken;
            this.GetUserGraphQL();

            if(this.user.signInUserSession.idToken.payload['cognito:groups']){
                this.user.signInUserSession.idToken.payload['cognito:groups'].forEach((group)=>{
                    if(group == 'Admin'){
                      this.AdminUser = true;
                    }

                    if(group == 'InternalAdmin'){
                        this.InternalAdmin = true;
                    }

                    if(group == 'Customer'){
                        this.Customer = true;
                    }

                    if(group == 'CustomerAdmin'){
                        this.CustomerAdmin = true;
                    }

                    if(group == 'ManagePrices'){
                        this.ManagePrices = true;
                    }

                    if(group == 'EditorGroup'){
                        this.EditorGroup = true;
                    }
                })
                if (!this.AdminUser && !this.InternalAdmin) {
                    alert("Access denied to pickup dashboard")
                    // Redirect to the shipment page
                    this.$router.push('/ShipmentDashboard');
                }
            }
        }).catch(error => {
          if(error){
            this.$router.push('Login');
            Auth.signOut({global: false})
          }
        });
    },
    methods:{
        async GetShipmentData(){
            this.shipmentData = null
            this.UPSCreateShipmentData = null
            this.labelData = null;
            this.loadingData = true;
            try{
                let getShipment = await API.graphql({
                query:  `query getShipment{
                        getShipment(shipmentID: "${this.shipmentID}"){
                            shipmentID
                            weight
                            externalTrackingNumber
                            description
                            deliveryInstructions
                            serviceAddress{
                            address{
                                companyName
                                address1
                                address2
                                city
                                state
                                zipCode
                                attention
                                phone
                                latitude
                                longitude
                                relevance
                            }
                            }
                            deliveryPickup{
                            address{
                                companyName
                                address1
                                address2
                                city
                                state
                                zipCode
                                attention
                                phone
                                latitude
                                longitude
                                relevance
                            }
                            }
                        }
                        }`,
                authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                if(getShipment.data.getShipment == null){
                    this.toggleAlertBox = true;
                    this.alertMessage = "Error getting shipment. Ensure the shipment exists in TNG."
                }else{
                    this.shipmentData = getShipment.data.getShipment;
                }
                this.loadingData = false
            }catch(e){
                console.log(e)
                if(e){
                    this.toggleAlertBox = true;
                    this.alertMessage = "Error getting shipment. Ensure the shipment exists in TNG."
                }
                this.loadingData = false
            }
        },
        async CreateUPSShipment(){
            this.loadingData = true;
            let createShipmentUPSInput = {
                shipmentID: this.shipmentData.shipmentID,
                deliveryPickup: {
                    address: {
                        address1: "2333 US Highway 22 W",
                        address2: "",
                        attention: "",
                        city: "Union",
                        companyName: "NJLS",
                        phone: "",
                        state: "NJ",
                        zipCode: "07083",
                        longitude: "-74.29351262381839",
                        latitude: "40.692692037700105",
                    },
                    type: this.shipmentData.deliveryPickup.type ?? "Address"
                },
                serviceAddress: {
                    address: {
                        address1: this.shipmentData.serviceAddress.address.address1 ?? "",
                        address2: this.shipmentData.serviceAddress.address.address2 ?? "",
                        attention: this.shipmentData.serviceAddress.address.attention ?? "",
                        city: this.shipmentData.serviceAddress.address.city ?? "",
                        companyName: this.shipmentData.serviceAddress.address.companyName?.trim() 
                                    ? this.shipmentData.serviceAddress.address.companyName 
                                    : "LREX",
                        phone: this.shipmentData.serviceAddress.address.phone ?? "",
                        state: this.shipmentData.serviceAddress.address.state ?? "",
                        zipCode: this.shipmentData.serviceAddress.address.zipCode ?? "",
                        longitude: this.shipmentData.serviceAddress.address.longitude ?? "",
                        latitude: this.shipmentData.serviceAddress.address.latitude ?? "",
                    },
                    type: this.shipmentData.deliveryPickup.type ?? "Address"
                },
                weight: this.shipmentData.weight ?? "",
            }
            try{
                let createShipmentUPSData = await API.graphql({
                query: createShipmentUPS,
                variables: {
                    input: createShipmentUPSInput
                },
                authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                if(createShipmentUPSData.data.createShipmentUPS == null){
                    this.toggleAlertBox = true;
                    this.alertMessage = "Error creating UPS shipment"
                }else if(createShipmentUPSData.data.createShipmentUPS.error){
                    this.toggleAlertBox = true;
                    this.alertMessage = createShipmentUPSData.data.createShipmentUPS.error
                }else{
                    this.UPSCreateShipmentData = createShipmentUPSData.data.createShipmentUPS;
                }
                this.loadingData = false
            }catch(e){
                console.log(e)
                if(e){
                    this.toggleAlertBox = true;
                    this.alertMessage = "Error creating UPS shipment"
                }
                this.loadingData = false
            }
        },
        async CreateUPSShipmentLabel(){
            this.loadingData = true;
            let createLabelUPSInput = {
                shipmentID: this.shipmentData.shipmentID,
                trackingNumber: this.shipmentData.externalTrackingNumber,
                labelFormat: "GIF"
            }
            try{
                let createLabelUPSData = await API.graphql({
                query: createLabelUPS,
                variables: {
                    input: createLabelUPSInput
                },
                authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                if(createLabelUPSData.data.createLabelUPS == null){
                    this.toggleAlertBox = true;
                    this.alertMessage = "Error creating UPS shipment label"
                }else if(createLabelUPSData.data.createLabelUPS.error){
                    this.toggleAlertBox = true;
                    this.alertMessage = createLabelUPSData.data.createLabelUPS.error
                }else{
                    this.UPSCreateShipmentData = createLabelUPSData.data.createLabelUPS;
                }
                this.loadingData = false
            }catch(e){
                console.log(e)
                if(e){
                    this.toggleAlertBox = true;
                    this.alertMessage = "Error creating UPS shipment label"
                }
                this.loadingData = false
            }
        },
        async manifestParcelP2P(){
            this.loadingData = true;
            try {
                let p2pManifestData = await API.graphql({
                    query: `mutation MyMutation {
                        manifestParcelP2P(input: {tripSheetID: "${this.tripSheetID}"}) {
                            Document
                            ManifestID
                            errors
                            status
                        }
                    }`,
                    authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                if(p2pManifestData.data.manifestParcelP2P.status == "success"){
                    if(p2pManifestData.data.manifestParcelP2P.Document){
                        this.showPDF = true;
                        document.getElementById('pdfViewer').src = "data:application/pdf;base64," + p2pManifestData.data.manifestParcelP2P.Document.replace(/(^"|"$)/g, '');
                    }
                    this.tripSheetID = null;
                    this.p2pUSPSShipmentData = null;
                    this.toggleSubmitTripSheet = false;
                    this.toggleAlertBox = true;
                    this.selectedPartner = "";
                    this.alertMessage = "Manifest Successful";
                }
                if(p2pManifestData.data.manifestParcelP2P.status == "error"){
                    this.toggleAlertBox = true;
                    this.alertMessage = "P2P Error: " + p2pManifestData.data.manifestParcelP2P.errors;
                    this.tripSheetID = null;
                    this.p2pUSPSShipmentData = null;
                    this.toggleSubmitTripSheet = false;
                    this.selectedPartner = "";
                }
                this.loadingData = false;
            } catch (error) {
                this.toggleAlertBox = true;
                this.alertMessage = JSON.stringify(error)
                this.loadingData = false;
            }
        },
        async processTrackingNumber() {
            let stringTrackingNumber = this.trackingNumber.toString();
            let noSpacesString = stringTrackingNumber.replace(/[^a-zA-Z0-9]/g, '');
            let resultString = noSpacesString.slice(8);
            this.trackingNumber = resultString;
        },
        async listTripSheetsUSPS(){
            this.loadingData = true;
            try {
                let p2pUSPSTripSheet = await API.graphql({
                    query: `query MyQuery {
                        listTripSheets(filter: {routeCode: {eq: "${this.P2PECORoute}"}, or: [{SignOffDate: {attributeExists: false}}, {SignOffDate: {eq: ""}}]}) {
                            nextToken
                            items {
                                routeCode
                                TripSheetId
                            }
                        }
                    }`,
                    authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                if(p2pUSPSTripSheet?.data?.listTripSheets?.items?.[0]){
                    if(p2pUSPSTripSheet.data.listTripSheets.items > 1){
                        this.toggleAlertBox = true;
                        this.alertMessage = "Multiple trip sheets exist. Fix this issue before proceeding."
                        this.loadingData = false;
                    }else{
                        this.tripSheetID = p2pUSPSTripSheet.data.listTripSheets.items[0].TripSheetId;
                        this.loadingData = false;
                    }
                }else{
                    this.toggleAlertBox = true;
                    this.alertMessage = "No trip sheet found. Creating new trip sheet.";
                    await this.createTripSheetP2PECO();
                }
            } catch (error) {
                this.toggleAlertBox = true;
                this.alertMessage = "Unable to get trip sheet information"
                this.loadingData = false;
            }
        },
        async getShipmentExternalTracking(){
            if(this.tripSheetID == null){
                this.toggleAlertBox = true;
                this.alertMessage = "Please add a trip sheet ID."
                return;
            }
            await this.processTrackingNumber();
            this.p2pUSPSShipmentData = null;
            this.loadingData = true;
            try {
                let externalTrackingNumberData = await API.graphql({
                    query: `query MyQuery {
                        shipmentByExternalTrackingNumber(externalTrackingNumber: "${this.trackingNumber}") {
                            nextToken
                            items {
                            shipmentID
                            externalTrackingNumber
                                serviceAddress {
                                    address {
                                        address1
                                        address2
                                        attention
                                        city
                                        companyName
                                        zipCode
                                        state
                                    }
                                }
                            }
                        }
                    }`,
                    authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                if(externalTrackingNumberData.data.shipmentByExternalTrackingNumber.items[0]){
                    this.p2pUSPSShipmentData = externalTrackingNumberData.data.shipmentByExternalTrackingNumber.items[0];
                    await this.restAddShipmentProcess(externalTrackingNumberData.data.shipmentByExternalTrackingNumber.items[0].shipmentID)
                }else{
                    this.toggleAlertBox = true;
                    this.alertMessage = "No shipment found with that tracking number."
                    this.p2pUSPSShipmentData = null;
                    this.loadingData = false;
                }
            } catch (error) {
                this.loadingData = false;
                this.toggleAlertBox = true;
                this.alertMessage = "Unable to get shipment information";
                this.p2pUSPSShipmentData = null;
            }
        },
        async createTripSheetP2PECO() {
            this.loadingData = true;
            const currentDate = new Date();

            const year = currentDate.getFullYear();
            const month = currentDate.getMonth() + 1; // Months are zero-based so add 1
            const day = currentDate.getDate();
            const hour = currentDate.getHours();
            const minute = currentDate.getMinutes();
            const second = currentDate.getSeconds();
            const millisecond = currentDate.getMilliseconds();

            const dateString = `${year}-${month}-${day} ${hour}:${minute}:${second}.${millisecond.toString().padStart(3, '0')}`;

            try {
                API.post('lrexsiterest', '/s2anjls/TripStart', {
                    headers: {
                        Authorization: process.env.VUE_APP_REST_AUTH
                    },
                    body: {
                        VehicleId: 1,
                        DriverId: 1,
                        RouteId: 210,
                        TripDate:  dateString,
                        StartingMileage: 1
                    }
                    })
                    .then(response => {
                        if(response.Message == "SUCCESS"){
                            this.toggleAlertBox = true;
                            this.alertMessage = "Trip sheet created."
                            this.tripSheetID = response.Result;
                            this.loadingData = false;
                        }
                    })
                    .catch(error => {
                        console.error('API Error', error);
                        this.toggleAlertBox = true;
                        this.alertMessage = "Error creating trip sheet."
                        this.loadingData = false;
                });
            } catch (e) {
                this.toggleAlertBox = true;
                this.alertMessage = "Error creating trip sheet."
                this.loadingData = false;
            }
        },
        async endTripSheetP2PECO() {
            this.loadingData = true;
            const currentDate = new Date();

            const year = currentDate.getFullYear();
            const month = currentDate.getMonth() + 1;
            const day = currentDate.getDate();
            const hour = currentDate.getHours();
            const minute = currentDate.getMinutes();
            const second = currentDate.getSeconds();
            const millisecond = currentDate.getMilliseconds();

            const dateString = `${year}-${month}-${day} ${hour}:${minute}:${second}.${millisecond.toString().padStart(3, '0')}`;

            try {
                API.post('lrexsiterest', '/s2anjls/TripEnd', {
                    headers: {
                        Authorization: process.env.VUE_APP_REST_AUTH
                    },
                    body: {
                        TripSheetId: this.tripSheetID,
                        SignOffId: 1,
                        EndingMileage:  2,
                        SignOffDate: dateString
                    }
                    })
                    .then(response => {
                        if(response.Message == "SUCCESS"){
                            this.toggleAlertBox = true;
                            this.alertMessage = "Trip sheet submitted."
                            this.manifestParcelP2P()
                        }
                    })
                    .catch(error => {
                        console.error('API Error', error);
                        this.toggleAlertBox = true;
                        this.alertMessage = "Error submitting trip sheet."
                        this.loadingData = false;
                });
            } catch (e) {
                this.toggleAlertBox = true;
                this.alertMessage = "Error submitting trip sheet."
                this.loadingData = false;
            }
        },
        async restAddShipmentProcess(shipmentID) {
            this.loadingData = true;
            const currentDate = new Date();

            const year = currentDate.getFullYear();
            const month = currentDate.getMonth() + 1;
            const day = currentDate.getDate();
            const hour = currentDate.getHours();
            const minute = currentDate.getMinutes();
            const second = currentDate.getSeconds();
            const millisecond = currentDate.getMilliseconds();

            const dateString = `${year}-${month}-${day} ${hour}:${minute}:${second}.${millisecond.toString().padStart(3, '0')}`;

            try {
                API.post('lrexsiterest', '/s2anjls/AddShipmentProcess', {
                    headers: {
                        Authorization: process.env.VUE_APP_REST_AUTH
                    },
                    body: {
                        TripSheetId: parseInt(this.tripSheetID),
                        ShipmentId: parseInt(shipmentID),
                        ShipmentStatusId: 62,
                        ProcessedDate:  dateString,
                        Latitude: "",
                        Longitude: "",
                        Altitude: "",
                        Courierinput: "USPS Scanned in Warehouse"
                    }
                    })
                    .then(response => {
                        console.log('API Response', response);
                        if(response.Message == "SUCCESS"){
                            this.toggleAlertBox = true;
                            this.alertMessage = "Shipment status updated."
                            this.trackingNumber = "";
                            this.loadingData = false;
                        }
                    })
                    .catch(error => {
                        console.error('API Error', error);
                        this.toggleAlertBox = true;
                        this.alertMessage = "Error updating shipment status."
                        this.loadingData = false;
                });
            } catch (e) {
                console.log('POST call failed: ', JSON.parse(e.response.body));
                this.toggleAlertBox = true;
                this.alertMessage = "Error updating shipment status."
                this.loadingData = false;
            }
        },
        async createP2PLabel(){
            this.loadingUser = true;
            try {
                let p2pLabelReturnData = await API.graphql({
                    query: createLabelP2P,
                    variables: {
                        input:{
                            UniqueParcelID: this.shipmentData.shipmentID
                        }
                    },
                    authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                this.p2pLabelReturnData = p2pLabelReturnData.data.createLabelP2P;
                if(this.p2pLabelReturnData.status == 'success'){
                    // this.toggleAlertBox = true;
                    // this.alertMessage = "Created P2P Label"
                    this.labelData = "data:application/pdf;base64, " + this.p2pLabelReturnData.Label;
                }else{
                    if(this.p2pLabelReturnData.errors != null){
                        this.toggleAlertBox = true;
                        this.alertMessage = this.p2pLabelReturnData.errors
                    }else{
                        this.toggleAlertBox = true;
                        this.alertMessage = "Unable to print label. Make sure parcel has been created in P2P."
                    }
                }
                this.loadingUser = false;
            } catch (error) {
                this.toggleAlertBox = true;
                this.alertMessage = "Unable to create P2P Parcel"
                this.loadingUser = false;
            }finally{
                this.loadingUser = false;
            }
        },
        async createP2PParcel(){
            if(this.p2pServiceCode == ""){
                this.toggleAlertBox = true;
                this.alertMessage = "Select a service type."
                return;
            }
            this.loadingUser = true;
            try {
                let p2pReturnData = await API.graphql({
                    query: createParcelP2P,
                    variables: {
                        input:{
                            UniqueParcelID: this.shipmentData.shipmentID,
                            ConsigneeName: this.shipmentData.serviceAddress.address.attention || "Not Provided",
                            JobName: "LREX",
                            ConsigneeBusinessName: this.shipmentData.serviceAddress.address.companyName || "",
                            ConsigneeStreetAddress1: this.shipmentData.serviceAddress.address.address1,
                            ConsigneeStreetAddress2: this.shipmentData.serviceAddress.address.address2 ?? "",
                            ConsigneeCity: this.shipmentData.serviceAddress.address.city,
                            ConsigneeStateOrProvince: this.shipmentData.serviceAddress.address.state,
                            ConsigneePostalCode: this.shipmentData.serviceAddress.address.zipCode,
                            ConsigneeCountry: "US",
                            ConsigneeTelephone: this.shipmentData.serviceAddress.address.phone ?? "",
                            ConsigneeEmail: this.shipmentData.serviceAddress.address.email ?? "",
                            DeliveryInstructions: this.shipmentData.deliveryInstructions ?? "",
                            WeightCode: "",
                            CurrencyCode: "",
                            ServiceRequired: this.p2pServiceCode,
                            Items: [{
                                ItemDescription: this.shipmentData.description && this.shipmentData.description.trim().length > 0 
                                ? this.shipmentData.description 
                                : "LREX Item",
                                LineItemQuantity: "1",
                                CountryOfOrigin: "US",
                                CustomsValue: "1",
                                Weight: this.shipmentData.weight > 0 ? this.shipmentData.weight : 1
                            }]
                        }
                    },
                    authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                this.p2pReturnData = p2pReturnData.data.createParcelP2P;
                if(this.p2pReturnData.status == 'success'){
                    this.toggleAlertBox = true;
                    this.alertMessage = "Created P2P Parcel. Label is being generated."
                    await this.createP2PLabel();
                }else{
                    this.toggleAlertBox = true;
                    this.alertMessage = this.p2pReturnData.errors
                }
                this.loadingUser = false;
            } catch (error) {
                this.toggleAlertBox = true;
                this.alertMessage = "Unable to create P2P Parcel"
                this.loadingUser = false;
            }finally{
                this.loadingUser = false;
            }
        },
        // async getShipmentDataREST(){
        //     this.labelData = null;
        //     this.loadingUser = true;
        //     try {
        //         let shipmentReturnData = await API.graphql({
        //             query: getShipmentDataREST,
        //             variables: {
        //                 input:{
        //                     shipmentID: this.userInput
        //                 }
        //             },
        //             authMode: "AMAZON_COGNITO_USER_POOLS",
        //         })
        //         this.shipmentDataREST = shipmentReturnData.data.getShipmentDataREST;
        //         this.loadingUser = false;
        //     } catch (error) {
        //         this.toggleAlertBox = true;
        //         this.alertMessage = "Unable to get shipment"
        //         this.loadingUser = false;
        //     }finally{
        //         this.loadingUser = false;
        //     }
        // },
        async selectPartner(partner){
            this.selectedPartner = "";
            this.selectedPartner = partner;

            if(partner == "USPSEconomy"){
                await this.listTripSheetsUSPS()
            }
        },
        async resetSelectedPartner(){
            this.selectedPartner = "";
            this.shipmentData = null;
            this.shipmentID = "";
            this.labelData = null;
        },
        submitForm() {
            // this.getShipmentDataREST()
            this.GetShipmentData()
            // Add additional logic or send data to a server as needed
        },
        toggleFinishScanning(){
            this.toggleAlertBox = true;
            this.alertMessage = "By clicking 'Submit' you are confirming that there are no other shipments that need to be scanned on this trip.";
            this.toggleSubmitTripSheet = true;
        },
        async checkBoxSelectID(event){
            this.createCognitoUserInput.locationID = event;
        },
        async GetUserGraphQL(){
            this.loadingUser = true;
            try {
                let userReturnData = await API.graphql({
                    query: `query GetUser($UserName: String!){
                        getUser(userName: $UserName){
                        userName
                        accountNo
                        fullname
                        locationID
                        userEmail
                        locationAddress{
                        labelImage
                        serviceAddress{
                            address{
                                companyName
                                attention
                                address1
                                address2
                                city
                                state
                                zipCode
                                phone
                                phoneExt
                                relevance
                                latitude
                                longitude
                                }
                        }
                        }
                        labelImage
                    }
                    }`,
                    variables: {
                            UserName: this.user.username
                    },
                    authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                this.userData = userReturnData.data.getUser;
            } catch (error) {
                this.toggleAlertBox = true;
                this.alertMessage = "Unable to get user information"
            }finally{
                this.loadingUser = false;
            }
        },
        closeAlertBox(toggleAlertBox){
            this.toggleAlertBox = toggleAlertBox;
        }
    }
}
</script>

<style scoped>
input {
	padding: 10px;
	font-size: 15px;
	border: 1px solid rgba(0, 0, 0, .336);
	border-radius: 15px;
	outline: 0;
	margin-top: 5px
}

html {
	background-color: #f3f3f3
}

.pdfViewer {
	border-radius: 15px;
	margin-bottom: 15px;
	margin-top: 15px
}

.submit-form {
	display: flex;
	align-items: center;
	gap: 10px;
	background-color: #fff;
	padding: 15px;
	border-radius: 25px;
	margin: 10px;
	box-shadow: rgba(0, 0, 0, .2) 0 5px 15px;
	width: fit-content
}

.submit-form button,
.submit-form input,
.submit-form label {
	margin: 0
}

.submit-form button {
	background-color: #e4e4e4;
	color: #000;
	border: none;
	border-radius: 999px;
	padding: 5px 15px;
	width: fit-content;
	transition-duration: .5s;
	cursor: pointer
}

.submit-form button:hover {
	transition-duration: .5s;
	background-color: #d5d5d5
}

.finish-scanning-button {
	background-color: #32ccfe;
	color: #000;
	border: none;
	border-radius: 999px;
	padding: 5px 15px;
	width: fit-content;
	transition-duration: .5s;
	cursor: pointer;
	margin-left: 10px;
	margin-top: 10px;
	text-decoration: none
}

.finish-scanning-button:hover {
	transition-duration: .5s;
	background-color: #2ebbea
}

.cancel-scanning-button {
	background-color: #e4e4e4;
	color: #000;
	border: none;
	border-radius: 999px;
	padding: 5px 15px;
	width: fit-content;
	transition-duration: .5s;
	cursor: pointer;
	margin-left: 10px;
	margin-top: 10px
}

.cancel-scanning-button:hover {
	transition-duration: .5s;
	background-color: #d5d5d5
}

.reset-button {
	background-color: #e4e4e4;
	color: #000;
	border: none;
	border-radius: 999px;
	padding: 5px 15px;
	width: fit-content;
	transition-duration: .5s;
	cursor: pointer;
}

.reset-button:hover {
	transition-duration: .5s;
	background-color: #d5d5d5
}

.address-container {
	box-shadow: rgba(0, 0, 0, .2) 0 5px 15px;
	padding: 12.5px;
	border-radius: 25px;
	margin-top: 5px
}

.selected-partner h3{
    background-color: #e2e2e2;
    padding: 5px 15px;
    border-radius: 999px;
    margin: 5px;
}

.selected-partner{
    background-color: #fff;
	border-radius: 25px;
    padding: 5px 15px;
	margin: 10px;
	box-shadow: rgba(0, 0, 0, .2) 0 5px 15px;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	width: fit-content;
}

.partner-option {
	background-color: #fff;
	padding: 15px;
	border-radius: 25px;
	margin: 10px;
	box-shadow: rgba(0, 0, 0, .2) 0 5px 15px;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	width: 30%;
	transition-duration: .5s;
	cursor: pointer
}

.partner-option:hover {
	transition-duration: .5s;
	background-color: #f2f2f2
}

.partner-option img {
	width: 80%
}

.label-container {
	margin-top: 5px;
	width: 100%
}

.shipment-data {
	background-color: #fff;
	padding: 15px;
	border-radius: 25px;
	margin: 10px;
	box-shadow: rgba(0, 0, 0, .2) 0 5px 15px;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	width: 30%;
	transition-duration: .5s
}

.shipmentid-data {
	background-color: #e4e4e4;
	color: #000;
	border: none;
	border-radius: 999px;
	padding: 5px 15px;
	width: fit-content
}

.create-button {
	background-color: #33f18a;
	color: #000;
	border: none;
	border-radius: 999px;
	padding: 5px 15px;
	width: fit-content;
	transition-duration: .5s;
	cursor: pointer;
	margin-top: 5px;
	align-self: flex-start
}

.create-button:hover {
	transition-duration: .5s;
	background-color: #2cd679
}

.create-label-button {
	background-color: #32ccfe;
	color: #000;
	border: none;
	border-radius: 999px;
	padding: 5px 15px;
	width: fit-content;
	transition-duration: .5s;
	cursor: pointer;
	margin-top: 5px;
	align-self: flex-start
}

.create-label-button:hover {
	transition-duration: .5s;
	background-color: #30bdec
}

.main-container {
	margin-top: 20px;
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center
}

.inner-container {
	width: 70%;
	background-color: #fff;
	box-shadow: rgba(0, 0, 0, .35) 0 5px 15px;
	border-radius: 25px;
	display: flex;
	flex-direction: row;
	justify-content: center;
	flex-wrap: wrap
}

.inner-overflow-container {
	width: 100%
}

.header-track-shipment {
	width: 100%;
	margin-bottom: 5px;
	display: flex;
	flex-direction: row;
	align-items: center
}

.header-track-inner {
	display: flex;
	flex-direction: row;
	align-items: center;
	width: fit-content;
	background-color: #e2e2e2;
	padding: 5px 15px;
	border-radius: 999px
}

.header-track-inner svg {
	height: 22px;
	margin: 0
}

.header-track-shipment p {
	font-size: 18px;
	margin: 0;
	margin-left: 10px
}

.header-track-shipment {
	width: 100%;
	margin-bottom: 5px
}

.track-shipment {
	background-color: #fff;
	padding: 15px;
	border-radius: 25px;
	flex-basis: 25%;
	width: fit-content;
	height: fit-content;
	margin: 10px;
	box-shadow: rgba(0, 0, 0, .35) 0 5px 15px;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column
}

.address-info-container {
	background-color: #fff;
	padding: 15px;
	border-radius: 25px;
	flex-basis: 25%;
	margin: 10px;
	box-shadow: rgba(0, 0, 0, .35) 0 5px 15px;
	width: fit-content;
	height: fit-content;
	display: flex;
	flex-direction: row;
	align-items: center
}

.address-info {
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	text-align: left
}

.check-mark-item {
	margin-left: 10px;
	width: 30px;
	height: 30px;
	border-radius: 50px;
	background-color: #33f18a;
	display: flex;
	justify-content: center;
	align-items: center
}

.check-mark-item img {
	width: 20px
}

.create-user {
	flex-basis: 40%
}

.update-user {
	flex-basis: 60%
}

.update-user-button {
	background-color: #e4e4e4;
	color: #000;
	border: none;
	border-radius: 999px;
	padding: 5px 15px;
	width: fit-content;
	margin-top: 5px;
	margin-left: 10px;
	margin-bottom: 5px;
	transition-duration: .5s;
	cursor: pointer
}

.update-user-button:hover {
	transition-duration: .5s;
	background-color: #d5d5d5
}

.confirmLabelContainer {
	margin-bottom: 5px
}

.label-image {
	width: 20em
}

.ups-label-container {
	margin: 10px;
	width: fit-content;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	background-color: #fff;
	padding: 15px;
	border-radius: 25px;
	box-shadow: rgba(0, 0, 0, .35) 0 5px 15px
}

.user-info {
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	text-align: left
}

.user-info p {
	margin: 0
}

.update-user-button {
	background-color: #e4e4e4;
	color: #000;
	border: none;
	border-radius: 999px;
	padding: 5px 15px;
	width: fit-content;
	margin-top: 5px;
	margin-left: 10px;
	margin-bottom: 5px;
	transition-duration: .5s;
	cursor: pointer
}

.update-user-button:hover {
	transition-duration: .5s;
	background-color: #d5d5d5
}

.service-type {
	width: 100%;
	text-align: left;
	font-weight: 700;
	margin-top: 5px
}

.signatureInputLabel {
	display: flex;
	flex-direction: row;
	width: 100%;
	justify-content: flex-start;
	align-items: center;
	margin-bottom: 5px
}

.signatureInputLabel label {
	padding-bottom: 5px;
	padding-right: 5px;
	padding-top: 5px;
	text-align: left
}

.signatureInputLabel input {
	margin-left: auto !important
}

input[type=radio] {
	-webkit-appearance: none;
	appearance: none;
	background-color: #fff;
	margin: 0;
	cursor: pointer;
	font: inherit;
	color: #33f18a;
	width: 1.05em;
	height: 1.05em;
	border: .15em solid #c4c4c4;
	border-radius: 999px;
	padding: 0;
	display: grid;
	place-content: center;
	transition-duration: .5s
}

input[type=radio]:hover {
	background-color: #f3f3f3;
	transition-duration: .5s
}

input[type=radio]::before {
	content: "";
	width: .65em;
	height: .65em;
	transform: scale(0);
	transform-origin: bottom left;
	transition: 120ms transform ease-in-out;
	background-color: #33f18a;
	border-radius: 999px
}

input[type=radio]:checked::before {
	transform: scale(1)
}

@media only screen and (max-width:1300px) {
	.inner-container {
		width: 85%
	}
}

@media only screen and (max-width:1000px) {

	.data-container-main,
	.inner-track-shipment-container {
		flex-wrap: wrap
	}

	.track-shipment {
		flex-basis: 70%
	}

	.data-container {
		flex-basis: 40%
	}

	.partner-option {
		width: 60%
	}

	.shipment-data {
		width: 60%
	}
}

@media only screen and (max-width:600px) {
	.inner-container {
		width: 95%
	}

	.data-container {
		flex-basis: 80%
	}

	.track-shipment {
		flex-basis: 80%
	}

	.address-info-container {
		flex-direction: column;
		margin-right: 0;
		margin-left: 0
	}

	.submit-form {
		flex-direction: column
	}
}
</style>